// src/features/locker-assignments/hooks/useLockerAssignmentPermissions.ts
import { usePermissions } from 'react-admin';

export interface UseLockerAssignmentPermissionsResult {
  canList: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canAssignPhysical: boolean;
  canArchive: boolean;
  canViewAccessLogs: boolean;
  role: string | null;
}

export const useLockerAssignmentPermissions = (): UseLockerAssignmentPermissionsResult => {
  const { permissions } = usePermissions();
  const role = permissions || null;

  return {
    canList: ['SuperAdmin', 'GroupAdmin', 'HotelAdmin', 'Receptionist'].includes(role),
    canCreate: ['SuperAdmin', 'GroupAdmin', 'HotelAdmin', 'Receptionist'].includes(role),
    canEdit: ['SuperAdmin', 'GroupAdmin', 'HotelAdmin', 'Receptionist'].includes(role),
    canDelete: ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role),
    canAssignPhysical: ['SuperAdmin', 'GroupAdmin', 'HotelAdmin', 'Receptionist'].includes(role),
    canArchive: ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role),
    canViewAccessLogs: ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role),
    role,
  };
};